import styled from "styled-components";

export const Wrapper = styled.div`
  margin: 2rem 2rem 0 0;
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    padding: 0 0 0 20px;

    font-size: 14px;
    line-height: 1.3;
    text-align: justify;
    font-variant: tabular-nums;

    color: ${({ theme }) => theme.colors.textColor};
  }

  @media screen and (max-width: 427px) {
    flex-direction: column;

    span {
      padding: 10px 0 0;
    }
  }
`;

export const ImageWrapper = styled.div`
  min-width: 5.625rem;
  min-height: 5.625rem;

  img {
    object-fit: contain;
  }
`;
